/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_View_MoreInputs */

const en_directory_launch_view_more = /** @type {(inputs: Directory_Launch_View_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View more launches`)
};

const zh_directory_launch_view_more = /** @type {(inputs: Directory_Launch_View_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看更多发布`)
};

/**
* | output |
* | --- |
* | "View more launches" |
*
* @param {Directory_Launch_View_MoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_view_more = /** @type {((inputs?: Directory_Launch_View_MoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_View_MoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_view_more(inputs)
	return zh_directory_launch_view_more(inputs)
});
export { directory_launch_view_more as "directory.launch.view_more" }